import { API_v2 } from '@/services/config';
import { request } from '@@/exports';

/**
 * 查询字典
 * @param params
 * @param options
 */
export async function getDictList(
  params: {
    page?: number;
    pageSize?: number;
    parent_id?: string | number;
    query_all?: string | number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getDictList, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/**
 *   修改字典
 * @param data
 * @param options
 */
export async function editDict(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.editDict, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 *   新增字典
 * @param data
 * @param options
 */
export async function addDict(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.addDict, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 身份证识别
 * @param data
 * @param options
 */
export async function recognitionIdCard(data: any, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.recognitionIdCard, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 查询项目列表-临时
 * @param params
 * @param options
 */
export async function getProjectListM(
  params: {
    page?: number;
    pageSize?: number;
    companyName?: string;
    tin?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getProjectListM, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}
/**
 * 查询发票列表-临时
 * @param params
 * @param options
 */
export async function getInvoiceListM(
  params: {
    page?: number;
    pageSize?: number;
    projectId?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getInvoiceListM, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}
/**
 *   批量导入
 * @param data
 * @param options
 */
export async function importInvoiceTemp(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    invoice?: [];
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.importInvoiceTemp, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 。流水列表-临时
 * @param params
 * @param options
 */
export async function getBankAccount(
  params: {
    page?: number;
    pageSize?: number;
    projectId?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getBankAccount, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}
/**
 * 。完税凭证-临时
 * @param params
 * @param options
 */
export async function getDutyPaidProofListM(
  params: {
    page?: number;
    pageSize?: number;
    projectId?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getDutyPaidProofListM, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}
/**
 *   批量导入完税凭证
 * @param data
 * @param options
 */
export async function importDPPTemp(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    dpp?: [];
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.importDPPTemp, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 。外经证-临时
 * @param params
 * @param options
 */
export async function getTaxCrossRegionalListM(
  params: {
    page?: number;
    pageSize?: number;
    projectId?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getTaxCrossRegionalListM, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}
/**
 *   批量导入外经证
 * @param data
 * @param options
 */
export async function importTCRTemp(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    tcr?: [];
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.importTCRTemp, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 。账户-临时
 * @param params
 * @param options
 */
export async function getBankAccountM(
  params: {
    page?: number;
    pageSize?: number;
    projectId?: string;
    tin?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getBankAccountM, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}
/**
 * 。流水-临时
 * @param params
 * @param options
 */
export async function getAccountBookM(
  params: {
    page?: number;
    pageSize?: number;
    projectId?: string;
    companyId?: string;
    accountNo?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getAccountBookM, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}
/**
 *   批量导入外经证
 * @param data
 * @param options
 */
export async function importFTTemp(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    ft?: [];
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.importFTTemp, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
